const corporateFinance = {
  'corporateFinance.page.lastUpdated': '最終更新: 2026年6月13日',
  'corporateFinance.page.backToTop': 'ページトップへ戻る',
  'corporateFinance.jsonld.serviceName': '金融・プライベートバンク向け接遇研修｜富裕層対応の所作',
  'corporateFinance.jsonld.orgName': '一般社団法人全日本執事協会',
  'corporateFinance.jsonld.serviceType': '金融機関向け接遇研修',
  'corporateFinance.jsonld.areaServed': '日本',
  'corporateFinance.jsonld.description': '金融機関向けの富裕層営業接遇研修。半日220,000円税込〜、出張対応、コンプライアンス配慮。執事教育の手法で所作・距離感・守秘を鍛えます。',
  'corporateFinance.jsonld.breadcrumb1': 'ホーム',
  'corporateFinance.jsonld.breadcrumb2': '法人研修',
  'corporateFinance.jsonld.breadcrumb3': '金融・プライベートバンク向け',
  'corporateFinance.hero.homeLink': 'ホーム',
  'corporateFinance.hero.corporateLink': '法人研修',
  'corporateFinance.hero.currentPage': '金融・プライベートバンク向け',
  'corporateFinance.hero.title': '金融・プライベートバンク向け 法人研修',
  'corporateFinance.hero.titleEn': 'FOR PRIVATE BANKING & FINANCE',
  'corporateFinance.hero.lead': '金融向け研修は、富裕層のお客様への所作・距離感・守秘を執事の基準で鍛える、日本の執事学校のプログラムです。',
  'corporateFinance.hero.ctaBtn': 'この業種で相談する',
  'corporateFinance.hero.imgAlt': '応接室で顧客にお茶を出す所作の整った日本人プライベートバンカー',
  'corporateFinance.hero.badge1': '仕え方の品質で信頼を築く',
  'corporateFinance.hero.badge2': '出張型で貴社の応接室・会議室にて実施',
  'corporateFinance.hero.badge3': '執事養成課程と同一の講師陣',
  'corporateFinance.pain.label': 'CHALLENGES',
  'corporateFinance.pain.title': 'こんな課題をお持ちではありませんか',
  'corporateFinance.pain.subtitleEn': 'Common Challenges',
  'corporateFinance.pain.lead': '商品や手数料の差が縮まるほど、お客様は「誰に任せるか」で選ぶようになります。面談室での所作や会食の段取りは、提案書には表れない実力の差です。',
  'corporateFinance.pain.item1': '商品や手数料では差別化しにくく、最後は担当者の人間的な信頼で選ばれます。面談室での所作や会食の段取りは、提案書には表れない実力の差です。',
  'corporateFinance.pain.item2': '面談・会食・訪問など「商談の外側」の所作に自信が持てず、せっかくの提案が印象の部分で損なわれているかもしれません。',
  'corporateFinance.pain.item3': '守秘と距離感を個人の感覚に任せており、担当者によって線引きが異なることが部門全体のリスクになっています。',
  'corporateFinance.pain.item4': 'お客様ご本人だけでなく、次世代（二代目・後継者）との関係づくりが課題です。長期的な信頼の土台をどのように築くかが問われています。',
  'corporateFinance.why.label': 'WHY BUTLER TRAINING',
  'corporateFinance.why.title': '執事研修が金融に効く理由',
  'corporateFinance.why.subtitleEn': 'Why Butler Training Works',
  'corporateFinance.why.lead': '執事研修と富裕層営業は、同じ構造の信頼関係を扱っています。',
  'corporateFinance.why.item1.title': '資産家に最も近い職業の作法',
  'corporateFinance.why.item1.desc': '執事は資産家に最も近い場所で信頼を積み上げてきた職業であり、その作法は富裕層営業の作法と地続きです。「仕える」ことを職業として磨かれた技術は、お客様に押し付けがましさを感じさせず、自然な信頼関係を育みます。',
  'corporateFinance.why.item2.title': '「売る技術」ではなく「仕える技術」を訓練',
  'corporateFinance.why.item2.desc': '当研修が扱うのは商談技法ではありません。所作・距離感・守秘といった、信頼の土台を実技で鍛えます。結果としてお客様が「この人に任せたい」と感じる関係性が、押し付けなく築かれることを狙います。',
  'corporateFinance.why.item3.title': '金融研修では扱われにくい領域を補完',
  'corporateFinance.why.item3.desc': '会食の席次判断、お客様宅への訪問時の振る舞い、贈答の作法など、一般的な金融機関の社内研修では扱われにくい領域を実技で補います。提案書の書き方ではなく、提案する「人」の磨き方を提供します。',
  'corporateFinance.programs.label': 'RECOMMENDED PROGRAMMES',
  'corporateFinance.programs.title': 'おすすめプラン',
  'corporateFinance.programs.subtitleEn': 'Recommended for Finance',
  'corporateFinance.programs.lead': '貴社の課題と目的に合わせてプランをお選びください。',
  'corporateFinance.programs.recommended': 'おすすめ',
  'corporateFinance.programs.currency': '円（税込）',
  'corporateFinance.programs.ctaBtn': 'このプランについて相談する',
  'corporateFinance.programs.p1.title': '半日プラン例',
  'corporateFinance.programs.p1.duration': '3時間',
  'corporateFinance.programs.p1.modules': 'M2（VIP・富裕層対応の原則）＋ M3（応接・お茶出し実技）',
  'corporateFinance.programs.p1.desc': '富裕層対応の基本原則と応接の実技に集中する短期プランです。まずは管理職が基準を体得する導入研修としてご利用いただけます。',
  'corporateFinance.programs.p2.title': '1日プラン例',
  'corporateFinance.programs.p2.duration': '6時間',
  'corporateFinance.programs.p2.modules': 'M1（立ち居振る舞い）＋ M2 ＋ M3 ＋ M4（想定外対応ロールプレイング）',
  'corporateFinance.programs.p2.desc': '所作からVIP対応、ロールプレイングまで、富裕層営業の接遇基盤を1日で網羅する推奨プランです。',
  'corporateFinance.programs.p3.title': '役員・支店長向け',
  'corporateFinance.programs.p3.duration': '半日（3時間）',
  'corporateFinance.programs.p3.modules': '管理職がまず基準を体得し、現場へ展開する形を推奨',
  'corporateFinance.programs.p3.desc': '管理職の皆様が先に基準を体得することで、現場への展開がスムーズになります。貴社の会議室1室で実施可能です。',
  'corporateFinance.programs.detailNote': 'モジュールの詳細は',
  'corporateFinance.programs.detailLink': '法人研修総合ページ',
  'corporateFinance.programs.detailSuffix': 'をご覧ください。',
  'corporateFinance.scenario.label': 'SCENARIO TRAINING',
  'corporateFinance.scenario.title': 'シナリオ研修',
  'corporateFinance.scenario.subtitleEn': 'Finance Scenarios',
  'corporateFinance.scenario.lead': '金融現場を想定した3つのシナリオで実践力を高めます。',
  'corporateFinance.scenario.note': '※コンプライアンスに配慮し、教材・事例はすべて一般化したものを使用します。',
  'corporateFinance.scenario.s1.title': '応接室での面談',
  'corporateFinance.scenario.s1.desc': 'お出迎えからお茶出し、資料の差し出し方、お見送りまでの一連の所作を磨きます。お客様が最初に感じる「この人なら大丈夫」という安心感を、すべての動作に込める技術を習得します。',
  'corporateFinance.scenario.s2.title': '会食の段取り',
  'corporateFinance.scenario.s2.desc': '席次の判断、注文とお支払いのスマートな進め方、会話の距離感をロールプレイングで確認します。お客様に気を遣わせず、それでいて格式を保つ振る舞いを、実践的な演習で身につけます。',
  'corporateFinance.scenario.s3.title': 'お客様宅への訪問',
  'corporateFinance.scenario.s3.desc': '玄関先の振る舞い、手土産の渡し方と渡すタイミング、長居しない引き際の判断まで、訪問時の一連の所作を実技で身につけます。ご家族がいらっしゃる場での距離感も訓練します。',
  'corporateFinance.roles.label': 'TARGET ROLES',
  'corporateFinance.roles.title': '対象者',
  'corporateFinance.roles.subtitleEn': 'Who Should Attend',
  'corporateFinance.roles.lead': '以下の方々に特におすすめします。',
  'corporateFinance.roles.r1': 'プライベートバンカー',
  'corporateFinance.roles.r2': '富裕層担当営業',
  'corporateFinance.roles.r3': '支店長・管理職',
  'corporateFinance.roles.r4': '秘書室',
  'corporateFinance.roles.r5': '受付・ロビー担当',
  'corporateFinance.roles.capacity': '推奨12名まで',
  'corporateFinance.roles.capacityNote': '超過する場合は2班制等をご提案します。本社研修室・支店会議室への出張実施に対応し、役員・支店長向けの少人数セッションは貴社の会議室1室で実施可能です。',
  'corporateFinance.pricing.label': 'PRICING',
  'corporateFinance.pricing.title': '料金プラン',
  'corporateFinance.pricing.subtitleEn': 'Transparent Pricing',
  'corporateFinance.pricing.lead': '全て税込表示です。貴社の規模と目標に合わせてお選びください。',
  'corporateFinance.pricing.header.plan': 'プラン',
  'corporateFinance.pricing.header.duration': '時間',
  'corporateFinance.pricing.header.price': '料金（税込）',
  'corporateFinance.pricing.header.note': '内容',
  'corporateFinance.pricing.recommended': '標準',
  'corporateFinance.pricing.currency': '円',
  'corporateFinance.pricing.plan1.name': '半日プラン',
  'corporateFinance.pricing.plan1.duration': '3時間',
  'corporateFinance.pricing.plan1.note': '2モジュール選択',
  'corporateFinance.pricing.plan2.name': '1日プラン',
  'corporateFinance.pricing.plan2.duration': '6時間',
  'corporateFinance.pricing.plan2.note': '4モジュール選択',
  'corporateFinance.pricing.plan3.name': '2日間パッケージ',
  'corporateFinance.pricing.plan3.duration': '2日間（各6時間）',
  'corporateFinance.pricing.plan3.note': '全モジュール対応',
  'corporateFinance.pricing.plan4.name': '継続プログラム',
  'corporateFinance.pricing.plan4.duration': '月1回半日×6ヶ月',
  'corporateFinance.pricing.plan4.note': '定着と改善を繰り返す長期設計',
  'corporateFinance.pricing.conditions.title': '共通条件',
  'corporateFinance.pricing.conditions.dispatch': '出張時の交通費は実費別途',
  'corporateFinance.pricing.conditions.capacity': '推奨12名まで。超過する場合は2班制等をご提案します',
  'corporateFinance.pricing.conditions.payment': 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  'corporateFinance.pricing.conditions.cancel': 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
  'corporateFinance.pricing.allMenuNote': '継続プログラム・覆面サービス診断などの全メニューは',
  'corporateFinance.pricing.allMenuLink': '法人研修総合ページ',
  'corporateFinance.pricing.allMenuSuffix': 'をご覧ください。',
  'corporateFinance.pricing.ctaBtn': '研修についてお問い合わせ',
  'corporateFinance.flow.label': 'FLOW',
  'corporateFinance.flow.title': 'ご利用の流れ',
  'corporateFinance.flow.subtitleEn': 'From Enquiry to Results',
  'corporateFinance.flow.lead': 'お問い合わせから実施後レポートまで、5ステップでご案内します。',
  'corporateFinance.flow.step1.title': 'お問い合わせ',
  'corporateFinance.flow.step1.desc': 'フォームまたはお電話・メールにてご連絡ください。',
  'corporateFinance.flow.step2.title': 'ヒアリング',
  'corporateFinance.flow.step2.desc': '対象層・課題・希望時期などをオンラインまたはお電話で伺います。事前に研修内容資料をお送りすることも可能です。',
  'corporateFinance.flow.step3.title': 'プログラム提案・お見積り',
  'corporateFinance.flow.step3.desc': 'ヒアリング内容をもとに、貴社に最適な研修プログラムとお見積りをご提案します。稟議用の概算お見積りのみのご依頼でも構いません。',
  'corporateFinance.flow.step4.title': '実施',
  'corporateFinance.flow.step4.desc': '出張または来校にて研修を実施します。出張型では貴社の本社研修室・支店会議室で実施し、役員・支店長向けの少人数セッションは会議室1室で実施可能です。',
  'corporateFinance.flow.step5.title': '実施後レポート',
  'corporateFinance.flow.step5.desc': '研修の総括と改善提案をまとめたレポートをお届けします。',
  'corporateFinance.contact.label': 'CONTACT',
  'corporateFinance.contact.title': 'お問い合わせ',
  'corporateFinance.contact.subtitleEn': 'Inquiry Form',
  'corporateFinance.contact.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。',
  'corporateFinance.contact.phoneLead': 'フォームのほか、お電話',
  'corporateFinance.contact.phoneOr': 'またはメール',
  'corporateFinance.contact.phoneAlso': 'でも承ります。',
  'corporateFinance.contact.hours': '受付時間: 平日 10:00〜17:00',
  'corporateFinance.contact.company': '会社名',
  'corporateFinance.contact.company.placeholder': '例: 株式会社〇〇',
  'corporateFinance.contact.department': '部署・役職',
  'corporateFinance.contact.department.placeholder': '例: 営業部・プライベートバンカー',
  'corporateFinance.contact.name': 'ご担当者名',
  'corporateFinance.contact.name.placeholder': '例: 山田 太郎',
  'corporateFinance.contact.name.required': '必須',
  'corporateFinance.contact.name.error': 'ご担当者名は必須です',
  'corporateFinance.contact.email': 'メールアドレス',
  'corporateFinance.contact.email.placeholder': '例: taro@example.com',
  'corporateFinance.contact.email.required': '必須',
  'corporateFinance.contact.email.error': 'メールアドレスは必須です',
  'corporateFinance.contact.email.invalid': '有効なメールアドレスを入力してください',
  'corporateFinance.contact.phone': '電話番号',
  'corporateFinance.contact.phone.placeholder': '例: 03-XXXX-XXXX',
  'corporateFinance.contact.phone.required': '必須',
  'corporateFinance.contact.phone.error': '電話番号は必須です',
  'corporateFinance.contact.businessType': '業態',
  'corporateFinance.contact.businessType.required': '必須',
  'corporateFinance.contact.businessType.error': '業態をお選びください',
  'corporateFinance.contact.format': '研修形式',
  'corporateFinance.contact.participants': '参加人数（目安）',
  'corporateFinance.contact.participants.placeholder': '例: 10名',
  'corporateFinance.contact.timeline': '希望時期',
  'corporateFinance.contact.timeline.placeholder': '例: 来月中、〇月頃、未定',
  'corporateFinance.contact.message': 'ご質問・ご要望（任意）',
  'corporateFinance.contact.message.placeholder': '研修の目的、対象者、ご要望などをご記入ください。',
  'corporateFinance.contact.message.error': '500文字以内で入力してください',
  'corporateFinance.contact.submit.error': '送信中にエラーが発生しました。お手数ですが再度お試しいただくか、お電話にてお問い合わせください。',
  'corporateFinance.contact.submit': 'お問い合わせを送信する',
  'corporateFinance.contact.submitting': '送信中...',
  'corporateFinance.contact.businessType.select': '選択してください',
  'corporateFinance.contact.businessType.bank': '銀行',
  'corporateFinance.contact.businessType.securities': '証券',
  'corporateFinance.contact.businessType.trust': '信託',
  'corporateFinance.contact.businessType.insurance': '保険',
  'corporateFinance.contact.businessType.other': 'その他',
  'corporateFinance.contact.format.select': '選択してください',
  'corporateFinance.contact.format.dispatch': '出張',
  'corporateFinance.contact.format.onsite': '来校',
  'corporateFinance.contact.format.undecided': '未定',
  'corporateFinance.faq.label': 'FAQ',
  'corporateFinance.faq.title': 'よくあるご質問',
  'corporateFinance.faq.subtitleEn': 'Frequently Asked Questions',
  'corporateFinance.faq.otherNote': 'その他のご質問はフォームよりお寄せください',
  'corporateFinance.faq.q1': '執事の資格が取れる研修ですか？',
  'corporateFinance.faq.a1': 'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  'corporateFinance.faq.q2': '一般的な営業研修と何が違いますか？',
  'corporateFinance.faq.a2': '売り方ではなく「仕え方」を扱います。所作・距離感・守秘といった信頼の土台を実技で鍛える点が、商談技法中心の営業研修との違いです。',
  'corporateFinance.faq.q3': 'コンプライアンス上、社外研修に出せる内容か確認したいのですが。',
  'corporateFinance.faq.a3': '教材と演習事例はすべて一般化したものを使用し、貴社の顧客情報・商品情報には一切触れません。事前に内容資料をお送りしますのでご確認ください。',
  'corporateFinance.faq.q4': '役員・支店長だけの少人数で実施できますか？',
  'corporateFinance.faq.a4': 'はい、可能です。管理職が先に基準を体得し、現場へ展開する形を推奨しています。',
  'corporateFinance.cta.label': 'GET STARTED',
  'corporateFinance.cta.title': 'まずはご相談ください',
  'corporateFinance.cta.lead': '貴社の課題をお聞かせいただければ、最適な研修プランを無料でご提案します。',
  'corporateFinance.cta.inquiryBtn': 'この業種で相談する',
  'corporateFinance.cta.coursesBtn': '法人研修トップへ戻る',
  'corporateFinance.related.label': 'OTHER INDUSTRIES',
  'corporateFinance.related.title': '他の業種向けプログラム',
  'corporateFinance.related.subtitleEn': 'Other Industry Programmes',
  'corporateFinance.related.viewDetail': '詳細を見る',
  'corporateFinance.related.r1.title': 'ホテル・旅館',
  'corporateFinance.related.r1.desc': 'バトラーサービスの型を開業前に整える',
  'corporateFinance.related.r2.title': '高級レジデンス',
  'corporateFinance.related.r2.desc': 'コンシェルジュ・フロントの接遇品質を統一',
  'corporateFinance.related.r3.title': '百貨店外商・高級小売',
  'corporateFinance.related.r3.desc': 'お得意様対応と訪問の作法',
  'corporateFinance.related.r4.title': 'ラグジュアリー営業',
  'corporateFinance.related.r4.desc': '高級車・宝飾・不動産の商談体験を設計',
  'corporateFinance.related.r5.title': '医療・美容クリニック',
  'corporateFinance.related.r5.desc': '自由診療の接遇を院内に定着',
  'corporateFinance.related.r6.title': '自動車・モビリティ',
  'corporateFinance.related.r6.desc': 'ブランド体験の接遇を高める',
  'corporateFinance.related.r7.title': 'ハイヤー・送迎',
  'corporateFinance.related.r7.desc': '乗降の所作と車内の気配りを磨く',
  'corporateFinance.related.coursesBtn': '個人向けコース（執事養成課程）を見る',
};

export default corporateFinance;
